import { ChangeDetectionStrategy, Component, computed, effect, inject, input, model, output } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { AbstractComponent, FieldWrapperComponent } from '@spike/scaffolds';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EquipmentRequestFormComponent } from '../../forms/equipment-request-form/equipment-request-form';
import { WorkflowApiService } from 'src/app/features/workflow/services/workflow-api.service';
import { FormFactoryService } from 'src/app/features/shared/services/form-factory.service';
import { OrganizationStoreService } from 'src/app/features/organizations/services/organization-store.service';
import { EquipmentRequest } from '../../models/equipment-request.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-create-equipment-request-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Button, Drawer, EquipmentRequestFormComponent, FieldWrapperComponent],
  templateUrl: './create-equipment-request-side-panel.html'
})
export class CreateEquipmentRequestSidePanelComponent extends AbstractComponent{


  private readonly workflowApiService = inject(WorkflowApiService);
  private readonly formFactory = inject(FormFactoryService);
  private readonly organizationStore = inject(OrganizationStoreService);

  // Inputs
  isDialogVisible = model.required<boolean>();
  data = input.required<EquipmentRequest>();
  readonly = input.required<boolean>();

  // Output
  public readonly onSave = output<void>();
  public readonly onClose = output<void>();

  public form: FormGroup<any> =this.formFactory.equipmentRequestForm();

  public readonly equipmentData= computed (()=>{
    const equipmentId = this.data().equipmentId!;
    return this.organizationStore.getEquipment(equipmentId)();
  });

  public readonly operations= computed (()=>{
    return this.data().operations??[];
  });



  constructor(){
    super();
    effect(()=>{
      const data = this.data();
      const readonly = this.readonly();
      
      if (data && this.form) {
        this.form.patchValue(data);
        if(readonly){
          this.form.disable();
        }
      }
    })
  }
  
  async onSaveClicked() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const generalValues = this.form.getRawValue() as EquipmentRequest;
      const operations = this.operations().filter(op => op.selected)
      let toSaveData: EquipmentRequest = {
        ...generalValues,
        operations: operations
      };     
      if(!toSaveData.requestId)
        await this.workflowApiService.createEquipmentRequest(toSaveData);
      else
        await this.workflowApiService.updateEquipmentRequest(toSaveData);
      this.onSave.emit();
    }
  }
}